export const SEARCH_PARAM_PAGE = 'page';
export const PAGINATION_PAGE_LIMIT = 5;
export const PAGE_SIZE = 12;
